import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core'
import { SquidexService } from '../../../../services/squidex.service';
import { Subscription } from 'rxjs'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'
import { take } from 'rxjs/operators'
import { SwiperOptions } from 'swiper/types'
@Component({
  selector: 'flowaccount-testimonial-partner',
  templateUrl: './testimonial-partner.component.html',
  styleUrls: ['./testimonial-partner.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TestimonialPartnerComponent implements OnInit {
  public testimonialList: any
  private TESTIMONIAL_PARTNER_KEY = 'testimonial_partner_key'
  TestimonialListSubscription: Subscription
  private SCORE_TESTIMONIAL_PARTNER_KEY = 'SCORE_TESTIMONIAL_PARTNER_KEY'
  public ServiceList: any
  private SubscriptionService: Subscription
  public config: SwiperOptions

  constructor(
    public readonly squidexService: SquidexService,
    private cdref: ChangeDetectorRef,
    protected tstate: TransferStateService,
  ) {}

  ngOnInit(): void {
    // After scully builded
    if (isScullyGenerated()) {
      this.tstate
        .useScullyTransferState(this.TESTIMONIAL_PARTNER_KEY, this.testimonialList)
        .subscribe((data: object[]) => {
          this.testimonialList = data
        })
      this.tstate
        .useScullyTransferState(this.SCORE_TESTIMONIAL_PARTNER_KEY, this.testimonialList)
        .subscribe((data: object[]) => {
          this.ServiceList = data
        })
    } else {
      // run every build
      this.getTestimonialList()
      this.getTotalService()
    }
    this.swiperConfig()
  }

  async getTestimonialList() {
    this.TestimonialListSubscription = await this.squidexService
      .getContentSquidexApiOrder('accounting-firm-partner-testimonial')
      .pipe(take(1))
      .subscribe((data: object[]) => {
        this.testimonialList = data
        this.tstate.setState(this.TESTIMONIAL_PARTNER_KEY, data)
        this.cdref.markForCheck()
      })
  }
  async getTotalService() {
    this.SubscriptionService = await this.squidexService
      .getContentSquidexApi('number-of-accounting-firm')
      .pipe(take(1))
      .subscribe((data: object[]) => {
        this.ServiceList = data
        this.tstate.setState(this.SCORE_TESTIMONIAL_PARTNER_KEY, data)
        this.cdref.markForCheck()
      })
  }

  swiperConfig() {
    this.config = {
      observer: true,
      observeParents: true,
      speed: 700,
      loop: false,
      keyboard: false,
      mousewheel: true,
      scrollbar: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        clickable: true,
        dynamicBullets: true,
      },
      injectStyles: [
        `
      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #2898cb;
        opacity: 0.4;
      }
      .swiper-pagination-bullet-active {
        opacity: 1;
      }
      `,
      ],
      breakpoints: {
        1000: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        650: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        400: {
          slidesPerView: 1,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        stopOnLastSlide: false,
        pauseOnMouseEnter: true,
      },
    }
  }

  linkToPartnerWebsite(event: any, link: string) {
    event.preventDefault()
    if (link) {
      window.open(link, '_blank')
    } else {
      event.stopPropagation()
    }
  }

  ngOnDestroy() {
    this.TestimonialListSubscription?.unsubscribe()
    this.SubscriptionService?.unsubscribe()
  }
}
